// extracted by mini-css-extract-plugin
module.exports = {"feedbackBtn":"feedbackBtn___39WpL","disable":"disable___NWxpy","icon":"icon___QIj89"};